import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const PersonaSelectionPopup = loadAsyncComponent(() => import('./Container'), 'popup');
